import { z } from 'zod';

/** Route path for `Link` / `useParams` / `useSearch` `from` (code-based tree). */
export const subscriptionDetailFullPath = '/users/$userId/subscription/$subscriptionId' as const;

/**
 * Path segments for `/users/$userId/subscription/$subscriptionId`.
 * Both ids are UUIDs now that Core migrated off integer PKs.
 */
export const subscriptionDetailParamsSchema = z.object({
  userId: z.string().min(1),
  subscriptionId: z.string().min(1),
});

export type SubscriptionDetailParams = z.infer<typeof subscriptionDetailParamsSchema>;

/**
 * Search state carried between user list → user detail → subscription detail
 * (tabs, filters, pagination, list context).
 */
export const subscriptionDetailSearchSchema = z.object({
  tab: z.string().optional().catch('dados'),
  subscriptionTerm: z.string().min(3).optional().catch(undefined),
  subscriptionStatus: z.string().optional().catch(undefined),
  subscriptionPage: z.coerce.number().min(1).optional().catch(undefined),
  subscriptionSize: z.coerce.number().min(1).optional().catch(undefined),
  usersTerm: z.string().min(3).optional().catch(undefined),
  usersPage: z.coerce.number().min(1).optional().catch(undefined),
  usersSize: z.coerce.number().min(1).optional().catch(undefined),
});

export type SubscriptionDetailSearch = z.infer<typeof subscriptionDetailSearchSchema>;
